module.exports = __webpack_public_path__ + "img/02-thumbnail.e52270b3.jpg";